import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import CustomMultiSelect, { CustomMultiSelectModel } from "../../../../components/CustomMultiSelect";
import CustomNumberInput from "../../../../components/CustomNumberInput";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomTextInput from "../../../../components/CustomTextInput";
import { ConstantService } from "../../../../services/ConstantService";

interface Props {
    name: string | undefined
    setName: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedDeviceBrand: CustomSingleSelectModel | undefined
    setSelectedDeviceBrand: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDeviceBrandDetail: CustomSingleSelectModel | undefined
    setSelectedDeviceBrandDetail: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDeviceConnectionTypes: CustomMultiSelectModel[]
    setSelectedDeviceConnectionTypes: React.Dispatch<React.SetStateAction<CustomMultiSelectModel[]>>
    selectedDeviceAccessories: CustomMultiSelectModel[]
    setSelectedDeviceAccessories: React.Dispatch<React.SetStateAction<CustomMultiSelectModel[]>>
    selectedVehicleBrand: CustomSingleSelectModel | undefined
    setSelectedVehicleBrand: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedVehicleBrandDetail: CustomSingleSelectModel | undefined
    setSelectedVehicleBrandDetail: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    modelYear: string | undefined
    setModelYear: React.Dispatch<React.SetStateAction<string | undefined>>
}

const GeneralInformation = ({
    name,
    setName,
    selectedDeviceBrand,
    setSelectedDeviceBrand,
    selectedDeviceBrandDetail,
    setSelectedDeviceBrandDetail,
    selectedDeviceConnectionTypes,
    setSelectedDeviceConnectionTypes,
    selectedDeviceAccessories,
    setSelectedDeviceAccessories,
    selectedVehicleBrand,
    setSelectedVehicleBrand,
    selectedVehicleBrandDetail,
    setSelectedVehicleBrandDetail,
    modelYear,
    setModelYear
}: Props) => {
    return (
        <KTCard className="ebbe-card">
            <KTCardBody>
                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                <div className='row'>
                    <div className="col-md-4">
                        <label htmlFor="exampleFormControlInput1" className="form-label required">Şablon</label>
                        <CustomTextInput value={name} setValue={setName} isDisabled />
                    </div>

                    <div className="col-md-4">
                        <label htmlFor="exampleFormControlInput1" className="form-label required">Cihaz Marka</label>

                        <CustomSingleSelect
                            selectedValue={selectedDeviceBrand}
                            onChange={(value) => {
                                setSelectedDeviceBrand(value);
                                setSelectedDeviceBrandDetail(undefined);
                            }}
                            onMenuOpen={() => ConstantService.getConstantList('DEVICE_BRAND')}
                            labelName='value'
                            valueName='constantId'
                            insertable={{
                                onSubmit: { code: 'DEVICE_BRAND' }
                            }}
                        />
                    </div>

                    <div className="col-md-4">
                        <label htmlFor="exampleFormControlInput1" className="form-label required">Cihaz Model</label>

                        <CustomSingleSelect
                            disabled={!selectedDeviceBrand}
                            selectedValue={selectedDeviceBrandDetail}
                            onChange={setSelectedDeviceBrandDetail}
                            onMenuOpen={() => ConstantService.getConstantList('DEVICE_BRAND_DETAIL', selectedDeviceBrand?.value)}
                            labelName='value'
                            valueName='constantId'
                            insertable={selectedDeviceBrand && {
                                onSubmit: { code: 'DEVICE_BRAND_DETAIL', parentConstantId: selectedDeviceBrand?.value }
                            }}
                        />
                    </div>
                </div>

                <div className="row mt-5">
                    <div className="col-md-4">
                        <label htmlFor="exampleFormControlInput1" className="form-label required">Bağlantı Türü</label>
                        <CustomMultiSelect
                            selectedValues={selectedDeviceConnectionTypes}
                            onChange={setSelectedDeviceConnectionTypes}
                            insertable={{
                                onSubmit: { code: 'DEVICE_CONNECTION_TYPE' }
                            }}
                            onMenuOpen={() => ConstantService.getConstantList('DEVICE_CONNECTION_TYPE')}
                            labelName='value'
                            valueName='constantId'
                            additionalValue1Name="additionalValue1"
                        />
                    </div>

                    <div className="col-md-4">
                        <label htmlFor="exampleFormControlInput1" className="form-label">Aksesuar</label>
                        <CustomMultiSelect
                            selectedValues={selectedDeviceAccessories}
                            onChange={setSelectedDeviceAccessories}
                            insertable={{
                                onSubmit: { code: 'DEVICE_ACCESSORY' }
                            }}
                            onMenuOpen={() => ConstantService.getConstantList('DEVICE_ACCESSORY')}
                            labelName='value'
                            valueName='constantId'
                            additionalValue1Name="additionalValue1"
                        />
                    </div>

                    <div className="col-md-4">
                        <label htmlFor="exampleFormControlInput1" className="form-label required">Araç Marka</label>

                        <CustomSingleSelect
                            selectedValue={selectedVehicleBrand}
                            onChange={(value) => {
                                setSelectedVehicleBrand(value);
                                setSelectedVehicleBrandDetail(undefined);
                            }}
                            onMenuOpen={() => ConstantService.getConstantList('VEHICLE_BRAND')}
                            labelName='value'
                            valueName='constantId'
                            insertable={{
                                onSubmit: { code: 'VEHICLE_BRAND' }
                            }}
                        />
                    </div>
                </div>

                <div className="row mt-5">
                    <div className="col-md-4">
                        <label htmlFor="exampleFormControlInput1" className="form-label required">Araç Model</label>

                        <CustomSingleSelect
                            disabled={!selectedVehicleBrand}
                            selectedValue={selectedVehicleBrandDetail}
                            onChange={setSelectedVehicleBrandDetail}
                            onMenuOpen={() => ConstantService.getConstantList('VEHICLE_BRAND_DETAIL', selectedVehicleBrand?.value)}
                            labelName='value'
                            valueName='constantId'
                            insertable={selectedVehicleBrand && {
                                onSubmit: { code: 'VEHICLE_BRAND_DETAIL', parentConstantId: selectedVehicleBrand?.value }
                            }}
                        />
                    </div>

                    <div className="col-md-4">
                        <label htmlFor="exampleFormControlInput1" className="form-label required">Model Yılı</label>
                        <CustomNumberInput maxLength={4} value={modelYear} setValue={setModelYear} />
                    </div>
                </div>

            </KTCardBody>
        </KTCard>
    )
}

export default GeneralInformation;